import { render, staticRenderFns } from "./NaleznosciGrup.vue?vue&type=template&id=20ac9c40&scoped=true&"
import script from "./NaleznosciGrup.vue?vue&type=script&lang=js&"
export * from "./NaleznosciGrup.vue?vue&type=script&lang=js&"
import style0 from "./NaleznosciGrup.vue?vue&type=style&index=0&id=20ac9c40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ac9c40",
  null
  
)

export default component.exports